module.exports = __webpack_public_path__ + "static/media/SendInvites.ed404948.svg";